import { clsx } from "@/src/utils/clsx"

/** ::before hit-area only. Use on elements that are already positioned. */
export const HIT_TARGET_PSEUDO_CLASS =
    "before:absolute before:inset-0 before:-inset-x-12 before:-bottom-12 before:-top-16 before:content-['']"

/** House 44px hit area without changing the visual box. See html-semantics.md. */
export const HIT_TARGET_CLASS = clsx("relative", HIT_TARGET_PSEUDO_CLASS)
